import { Card } from "flowbite-react";

const NextStepCard = ({ title, description }) => {
  return (
    <Card className="h-full rounded-3xl border-0 bg-white/90 shadow-lg backdrop-blur">
      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      <p className="text-sm leading-6 text-gray-700">{description}</p>
    </Card>
  );
};

export default NextStepCard;
